import { useState } from "react";
import {
    BACKUP_STORAGE_KEYS,
    getBackupStorageValue,
    setBackupStorageValue
} from "../../utils/matrixBackupStorage";

export const BACKUP_KEY_FORMS = {
    CREATE: "CREATE",
    RESET: "RESET",
    RESTORE: "RESTORE",
};

export const useBackupForm = (matrixClient) => {

    const [backupKeyChecksAreComplete, setBackupKeyChecksAreComplete] = useState(false);
    const [showBackupKeyForm, setShowBackupKeyForm] = useState(false);
    const [backupFormToShow, setBackupFormToShow] = useState("");
    const [userHasBackupKeys, setUserHasBackupKeys] = useState(false);

    const handleShowBackupKeyModal = async () => {
        const hasKeys = await checkIfUserHasExistingBackupKeys();
        const form = userHasBackupKeys || hasKeys
            ? BACKUP_KEY_FORMS.RESTORE
            : BACKUP_KEY_FORMS.CREATE;
        setUserHasBackupKeys(!!hasKeys);
        setBackupFormToShow(form);
        setShowBackupKeyForm(true);
    };

    const closeBackupKeyForm = (markActioned) => {
        if (markActioned !== false) {
            setBackupStorageValue(BACKUP_STORAGE_KEYS.BACKUP_MODAL_ACTIONED, matrixClient);
        }
        setShowBackupKeyForm(false);
    };

    const checkIfUserAlreadyRefusedToCreateBackupPassword = () => {
        return getBackupStorageValue(BACKUP_STORAGE_KEYS.BACKUP_MODAL_ACTIONED, matrixClient);
    };

    const clientHasCryptoEnabled = () => {
        return matrixClient && !!matrixClient.getCrypto();
    };

    /**
     * Check if the user has an existing backup version
     * @returns {Promise<boolean | null>}
     */
    const checkIfUserHasExistingBackupKeys = async () => {
        try {
            if (!clientHasCryptoEnabled()) return false;
            const crypto = matrixClient.getCrypto();
            const backupInfo = await crypto.getKeyBackupInfo();
            return !!backupInfo?.auth_data;
        } catch {
            setUserHasBackupKeys(false);
            setBackupFormToShow(BACKUP_KEY_FORMS.CREATE);
            return undefined;
        }
    };

    const runBackupKeyRequirementChecks = async () => {

        const cryptoIsEnabled = clientHasCryptoEnabled();
        if (!cryptoIsEnabled) {
            setBackupKeyChecksAreComplete(true);
            return;
        }

        const userPreviouslyDismissedPrompt = checkIfUserAlreadyRefusedToCreateBackupPassword();
        const backupKeysExist = await checkIfUserHasExistingBackupKeys();
        if (backupKeysExist === true) {
            setUserHasBackupKeys(true);
            const localStorageHasRestoredUserKey = getBackupStorageValue(
                BACKUP_STORAGE_KEYS.USER_KEY_RESTORED,
                matrixClient
            );
            if (!localStorageHasRestoredUserKey) {
                setBackupFormToShow(BACKUP_KEY_FORMS.RESTORE);
            }
        } else if (backupKeysExist === false && !userPreviouslyDismissedPrompt) {
            setBackupFormToShow(BACKUP_KEY_FORMS.CREATE);
        }

        setBackupKeyChecksAreComplete(true);
    };

    const updateBackupKeyFormToShow = () => {
        setBackupFormToShow(BACKUP_KEY_FORMS.RESET);
    };

    return {
        handleShowBackupKeyModal,
        closeBackupKeyForm,
        runBackupKeyRequirementChecks,
        setUserHasBackupKeys,
        setBackupFormToShow,
        updateBackupKeyFormToShow,
        backupKeyChecksAreComplete,
        showBackupKeyForm,
        backupFormToShow,
    };
};
